import React, { useState , useEffect} from "react";


const PopupOrdenYaCancelada = ({ message }) => {
     const [secondsRemaining, setSecondsRemaining] = useState(4); // Inicia con 15 segundos
     const [isLoading, setIsLoading] = useState(true); // Estado para mostrar el loading
    // Verificación de la estructura del mensaje de orden cancelada
    //  console.log(message);

    useEffect(() => {
      if (secondsRemaining > 0) {
        const timer = setInterval(() => {
          setSecondsRemaining((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
      } else {
        // Cuando el contador llegue a 0, recargar la página
        window.location.reload();
      }
    }, [secondsRemaining]);

  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "700px" }}
        >
          <div className="modal-content modal-succes">
            <div className="modal-body body-cita-confirmada">
              <p>{message}</p>
              <div/>
            {isLoading && (
              <p className="popup-loading">
                Serás redirigido a la página principal en {secondsRemaining} segundos...
              </p>
            )}
            </div>

          
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupOrdenYaCancelada;
